import { Chip } from '@mui/material'
import classNames from 'classnames'
import React, { ForwardedRef, useState } from 'react'
import {
  InputLabel,
  FormControl,
  FormControlProps,
  FormHelperText,
  Box,
} from 'ui'
import { SelectMultiple, SelectProps } from '../SelectMultiple'
import style from './SelectMultipleDropdown.module.scss'

export interface ISelectDropdown {
  children: React.ReactNode
  selectProps: SelectProps
  formControlProps?: FormControlProps
  icon?: React.ReactNode
  helperText?: string
  low?: boolean
  ref?: ForwardedRef<HTMLSelectElement> | undefined
  value: string[]
  onChange: (value: string[]) => void
}

export const SelectMultipleDropdown = React.forwardRef<
  HTMLSelectElement,
  ISelectDropdown
>(
  (
    {
      children,
      formControlProps,
      selectProps,
      icon,
      helperText,
      low,
      value,
      onChange,
    },
    ref,
  ) => {
    const [shrinkValue, setShrinkValue] = useState(false)
    return (
      <FormControl {...formControlProps}>
        {selectProps.label && (
          <InputLabel
            className={classNames({
              hasSelectIcon: !!icon,
              low,
            })}
            shrink={shrinkValue || Boolean(value.length)}
          >
            {selectProps.label}
            {selectProps.required && ' *'}
          </InputLabel>
        )}
        {icon && <div className={style.icon}>{icon}</div>}
        <SelectMultiple
          renderValue={selected => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {(selected as string[]).map((item: string) => (
                <Chip key={item} variant='outlined' label={item} />
              ))}
            </Box>
          )}
          {...selectProps}
          multiple
          ref={ref}
          onOpen={(event: React.SyntheticEvent<Element, Event>) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            selectProps.onOpen && selectProps.onOpen(event)
            setShrinkValue(true)
          }}
          onBlur={(
            event: React.FocusEvent<
              HTMLInputElement | HTMLTextAreaElement,
              Element
            >,
          ) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            selectProps.onBlur && selectProps.onBlur(event)
            setShrinkValue(false)
          }}
          className={classNames(style.select, {
            hasIcon: !!icon,
            isSelected: !!selectProps.value,
            low,
          })}
          onChange={e => onChange(e.target.value as string[])}
          value={value}
        >
          {children}
        </SelectMultiple>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    )
  },
)
